import React, {useState} from "react";
import {useTranslate} from "../../../../../hooks/translate.hook";
import {Col, Form, Input, Modal, Row} from "antd";
import {DeclarationsCode} from "../../../../../models/declarations/declarations.codes";
import {declarationsCodesService} from "../../../../../services/declarations/declarations.codes.service";

export interface DeclarationCodeEditModalProps {
    item: DeclarationsCode | null;
    onClose(): void;
}

export const DeclarationCodeEditModal: React.FC<DeclarationCodeEditModalProps> = ({item, onClose}) => {
    const t = useTranslate();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const initialValues: any = {};
    if (item) {
        initialValues.fullCode = item.fullCode;
        initialValues.shortCode = item.shortCode;
        initialValues.tarik = item.tarik;
        initialValues.lisa = item.lisa || "";
        initialValues.rahvuslik = item.rahvuslik || "";
    }

    return (
        <Modal
            open={true}
            confirmLoading={loading}
            title={t("DECLARATIONS.CODE_SPECIFICATION")}
            okText={item ? t("SAVE") : t("ADD")}
            cancelText={t("CANCEL")}
            onOk={() => form.submit()}
            onCancel={() => onClose()}
        >
            <Form
                form={form}
                layout="vertical"
                name={"address_form"}
                initialValues={initialValues}
                onFinish={() =>
                    form.validateFields().then(async (values) => {
                        setLoading(true);
                        try {
                            await (item
                                    ? declarationsCodesService.update(item.id, values)
                                    : declarationsCodesService.create(values)
                            );
                            onClose();
                        }
                        catch (e: any) {
                            if (e.response?.data?.fields) {
                                form.setFields(e.response?.data?.fields);
                            }
                            setLoading(false);
                        }
                    })
                }
            >
                <Row gutter={10}>
                    <Col span={24}>
                        <Form.Item
                            name="fullCode"
                            label={t("FULL_CODE")}
                            rules={[
                                {
                                    required: true,
                                    message: t("FROM.ERROR.PLEASE_ENTER_VALUE"),
                                },
                            ]}
                        >
                            <Input
                                disabled={loading}
                                placeholder={t("FULL_CODE")}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="shortCode"
                            label={t("SHORT_CODE")}
                            rules={[
                                {
                                    required: true,
                                    message: t("FROM.ERROR.PLEASE_ENTER_VALUE"),
                                },
                            ]}
                        >
                            <Input
                                disabled={loading}
                                placeholder={t("SHORT_CODE")}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="tarik"
                            label={"tarik"}
                            rules={[
                                {
                                    required: true,
                                    message: t("FROM.ERROR.PLEASE_ENTER_VALUE"),
                                },
                            ]}
                        >
                            <Input
                                disabled={loading}
                                placeholder={"tarik"}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="lisa"
                            label={"lisa"}
                        >
                            <Input
                                disabled={loading}
                                placeholder={"lisa"}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="rahvuslik"
                            label={"rahvuslik"}
                        >
                            <Input
                                disabled={loading}
                                placeholder={"rahvuslik"}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}
